import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/" className="header-logo">
            <img src={logo} alt="AGRO-INVEST" className="header-logo-img" />
          </Link>
          <p>AI-powered geospatial agricultural financing connecting farmers, suppliers, and investors for sustainable growth.</p>
        </div>
        <div className="footer-column">
          <h4>Platform</h4>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/marketplace">Marketplace</Link></li>
            <li><Link to="/impact-metrics">Impact</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Resources</h4>
          <ul>
            <li><Link to="/how-it-works#farmers">For Farmers</Link></li>
            <li><Link to="/how-it-works#investors">For Investors</Link></li>
            <li><Link to="/how-it-works#suppliers">For Suppliers</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/legal">Legal Documentation</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 AGRO-INVEST. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
